import { createNamedWrapperReducer } from '@core/utils/state';
import { isActionRelated } from '@core/utils/state';
import { IEntitiesState } from '../shared/entities/entities-state';
import { initialEmployeesState } from './employees-state';
import { IEmployeesState } from './employees-state';
import {
    GROUP_EMPLOYEES,
    GROUP_EMPLOYEE_BENEFITS,
    GROUP_EMPLOYEE_DEDUCTIONS,
    GROUP_EMPLOYEE_DOCUMENTS,
    GROUP_EMPLOYEE_PAYSTUBS,
    GROUP_EMPLOYEE_SUGGESTIONS,
    GROUP_EMPLOYEE_WAGES
} from '../state-groups';
import { reducer as listReducer } from '../shared/list/reducer';
import {
    EMPLOYEE_DOCUMENTS_FETCH,
    EMPLOYEE_DOCUMENTS_FETCH_MORE,
    EMPLOYEE_BENEFITS_FETCH,
    EMPLOYEE_BENEFITS_FETCH_MORE,
    EMPLOYEE_DEDUCTIONS_FETCH,
    EMPLOYEE_DEDUCTIONS_FETCH_MORE,
    EMPLOYEE_PAYSTUBS_FETCH,
    EMPLOYEE_PAYSTUBS_FETCH_MORE,
    EMPLOYEE_VIEWED_SET,
    EMPLOYEES_FETCH,
    EMPLOYEE_WAGES_FETCH
} from '../action-types';

export function reducer(
    state: IEmployeesState = initialEmployeesState(),
    action: any,
    entitySlice: IEntitiesState): IEmployeesState {        
      
    switch (action.type) {

        case EMPLOYEES_FETCH:
            return {
                ...state,
                employees: {
                    ...state.employees,
                    isFetching: true
                }
            };

        

        case EMPLOYEE_VIEWED_SET:
            return {
                ...state,
                viewedEmployeeId: action.payload.id
            };

        case EMPLOYEE_PAYSTUBS_FETCH:
            return {
                ...state,
                paystubs: {
                    ...state.paystubs, isFetching: true
                }
            };

        case EMPLOYEE_PAYSTUBS_FETCH_MORE:
            return {
                ...state,
                paystubs: {
                    ...state.paystubs, isFetchingMore: true
                }
            };

        case EMPLOYEE_DOCUMENTS_FETCH:
            return {
                ...state,
                documents: {
                    ...state.documents, isFetching: true
                }
            };

        case EMPLOYEE_DOCUMENTS_FETCH_MORE:
            return {
                ...state,
                documents: {
                    ...state.documents, isFetchingMore: true
                }
            };

        case EMPLOYEE_BENEFITS_FETCH:
            return {
                ...state,
                benefits: { 
                    ...state.benefits, isFetching: true
                }
            };

        case EMPLOYEE_BENEFITS_FETCH_MORE:
            return {
                ...state,
                benefits: {
                    ...state.benefits, isFetchingMore: true
                }
            };

        case EMPLOYEE_DEDUCTIONS_FETCH:
            return {
                ...state,
                deductions: { 
                    ...state.deductions, isFetching: true
                }
            };

        case EMPLOYEE_DEDUCTIONS_FETCH_MORE:
            return {
                ...state,
                deductions: {
                    ...state.deductions, isFetchingMore: true
                }
            };

        case EMPLOYEE_WAGES_FETCH:
            return {
                ...state,
                wages: {
                    ...state.wages, isFetching: true
                }
            };

        default:
            let nextState: IEmployeesState = state;

            if (isActionRelated(action, [
                    GROUP_EMPLOYEES,
                    GROUP_EMPLOYEE_SUGGESTIONS,
                    GROUP_EMPLOYEE_PAYSTUBS,
                    GROUP_EMPLOYEE_DOCUMENTS,
                    GROUP_EMPLOYEE_BENEFITS,
                    GROUP_EMPLOYEE_DEDUCTIONS,
                    GROUP_EMPLOYEE_WAGES
                ])) {
                nextState = {
                    ...state,
                    employees: createNamedWrapperReducer(
                        listReducer,
                        GROUP_EMPLOYEES
                    )(state.employees, action, entitySlice.entities),
                    paystubs: createNamedWrapperReducer(
                        listReducer,
                        GROUP_EMPLOYEE_PAYSTUBS
                    )(state.paystubs, action, entitySlice.entities),
                    documents: createNamedWrapperReducer(
                        listReducer,
                        GROUP_EMPLOYEE_DOCUMENTS
                    )(state.documents, action, entitySlice.entities),
                    benefits: createNamedWrapperReducer(
                        listReducer,
                        GROUP_EMPLOYEE_BENEFITS
                    )(state.benefits, action, entitySlice.entities),
                    deductions: createNamedWrapperReducer(
                        listReducer,
                        GROUP_EMPLOYEE_DEDUCTIONS
                    )(state.deductions, action, entitySlice.entities),
                    wages: createNamedWrapperReducer(
                        listReducer,
                        GROUP_EMPLOYEE_WAGES
                    )(state.wages, action, entitySlice.entities)
                };
            }

            return nextState;
    }
}
